var map = {
	"./ItGoals/1.svg": 1109,
	"./ItGoals/2.svg": 1110,
	"./ItGoals/3.svg": 1111,
	"./ItGoals/4.svg": 1112,
	"./ItGoals/courses/ai.png": 1298,
	"./ItGoals/courses/computer_literacy.png": 1299,
	"./ItGoals/courses/frontend.png": 1300,
	"./ItGoals/courses/game_design.png": 1301,
	"./ItGoals/courses/gamedev.png": 1302,
	"./ItGoals/courses/graphic_design.png": 1303,
	"./ItGoals/courses/main.png": 1304,
	"./ItGoals/courses/predprinimatelstvo.png": 1305,
	"./ItGoals/courses/programming_basics.png": 1306,
	"./ItGoals/courses/python.png": 1307,
	"./ItGoals/courses/scratch.png": 1308,
	"./ItGoals/courses/unity.png": 1309,
	"./ItGoals/courses/video_content.png": 1310,
	"./ItGoals/courses/videoblogging.png": 1311,
	"./ItGoals/courses/web-razrabotka.png": 1312,
	"./ItGoals/courses/webdev.png": 1313,
	"./ItGoals/coursesNew/ai.png": 1194,
	"./ItGoals/coursesNew/ai.webp": 1195,
	"./ItGoals/coursesNew/computer_literacy.png": 1196,
	"./ItGoals/coursesNew/computer_literacy.webp": 1197,
	"./ItGoals/coursesNew/ege-informatika-desk.png": 1198,
	"./ItGoals/coursesNew/ege-informatika-desk.webp": 1199,
	"./ItGoals/coursesNew/ege-informatika.png": 1200,
	"./ItGoals/coursesNew/ege-informatika.webp": 1201,
	"./ItGoals/coursesNew/frontend.png": 1202,
	"./ItGoals/coursesNew/frontend.webp": 1203,
	"./ItGoals/coursesNew/game_design.png": 1204,
	"./ItGoals/coursesNew/game_design.webp": 1205,
	"./ItGoals/coursesNew/graphic_design.png": 1206,
	"./ItGoals/coursesNew/graphic_design.webp": 1207,
	"./ItGoals/coursesNew/math-desk.png": 1208,
	"./ItGoals/coursesNew/math-desk.webp": 1209,
	"./ItGoals/coursesNew/math.png": 1210,
	"./ItGoals/coursesNew/math.webp": 1211,
	"./ItGoals/coursesNew/predprinimatelstvo.png": 1212,
	"./ItGoals/coursesNew/predprinimatelstvo.webp": 1213,
	"./ItGoals/coursesNew/programming_basics.png": 1214,
	"./ItGoals/coursesNew/programming_basics.webp": 1215,
	"./ItGoals/coursesNew/python.png": 1216,
	"./ItGoals/coursesNew/python.webp": 1217,
	"./ItGoals/coursesNew/scratch.png": 1218,
	"./ItGoals/coursesNew/scratch.webp": 1219,
	"./ItGoals/coursesNew/unity.png": 1220,
	"./ItGoals/coursesNew/unity.webp": 1221,
	"./ItGoals/coursesNew/videoblogging.png": 1222,
	"./ItGoals/coursesNew/videoblogging.webp": 1223,
	"./ItGoals/coursesNew/web-razrabotka.png": 1224,
	"./ItGoals/coursesNew/web-razrabotka.webp": 1225,
	"./ItGoals/cube.svg": 1314,
	"./ItGoals/cursor1.svg": 931,
	"./ItGoals/cursor2.svg": 932,
	"./ItGoals/cursor3.svg": 933,
	"./ItGoals/cursor4.svg": 934,
	"./ItGoals/enter.svg": 1315,
	"./ItGoals/globe.svg": 1316,
	"./ItGoals/outbreak.svg": 1317,
	"./ItGoals/puzzle.svg": 1318,
	"./ItGoals/story1.png": 1319,
	"./ItGoals/story2.png": 1320,
	"./ItGoals/story3.png": 1321,
	"./PlatformExample/PlatformLogo1.svg": 1190,
	"./PlatformExample/PlatformLogo2.svg": 1191,
	"./PlatformExample/PlatformLogo3.svg": 1192,
	"./PlatformExample/PlatformLogo4.svg": 1193,
	"./SK-base.svg": 1727,
	"./SK-dark.svg": 1728,
	"./achieve-yellow-big.svg": 1322,
	"./achieve-yellow-small.svg": 1323,
	"./alfa.svg": 1729,
	"./application-form-background-mobile.webp": 1266,
	"./application-form-background.webp": 1265,
	"./arrowButton.svg": 945,
	"./arrowRight.svg": 1730,
	"./components/footer/tg.svg": 1442,
	"./components/footer/vk.svg": 1440,
	"./components/footer/wa.svg": 1441,
	"./components/header/tg.svg": 1274,
	"./components/header/vk.svg": 1272,
	"./components/header/wa.svg": 1273,
	"./cross.svg": 1267,
	"./cursor-desk.svg": 1324,
	"./cursor-mobile.svg": 1325,
	"./detail/ai/6.1.png": 1122,
	"./detail/ai/6.2.png": 1123,
	"./detail/ai/6.3.png": 1124,
	"./detail/ai/6.svg": 961,
	"./detail/ai/7.svg": 946,
	"./detail/ai/line.3.svg": 1125,
	"./detail/ai/line.svg": 976,
	"./detail/ai/logoPage.png": 1042,
	"./detail/ai/logoPagePhone.png": 1027,
	"./detail/ai/spanBorder.svg": 1012,
	"./detail/arrow.svg": 1126,
	"./detail/computernaya-gramotnost/6.1.png": 1127,
	"./detail/computernaya-gramotnost/6.2.png": 1128,
	"./detail/computernaya-gramotnost/6.3.png": 1129,
	"./detail/computernaya-gramotnost/6.svg": 962,
	"./detail/computernaya-gramotnost/7.svg": 947,
	"./detail/computernaya-gramotnost/line.3.svg": 1130,
	"./detail/computernaya-gramotnost/line.svg": 977,
	"./detail/computernaya-gramotnost/logoPage.png": 1043,
	"./detail/computernaya-gramotnost/logoPagePhone.png": 1028,
	"./detail/computernaya-gramotnost/spanBorder.svg": 1013,
	"./detail/ege-informatika/6.1.png": 1131,
	"./detail/ege-informatika/6.2.png": 1132,
	"./detail/ege-informatika/6.3.png": 1133,
	"./detail/ege-informatika/6.svg": 963,
	"./detail/ege-informatika/7.svg": 948,
	"./detail/ege-informatika/line.3.svg": 1134,
	"./detail/ege-informatika/line.svg": 978,
	"./detail/ege-informatika/logoPage.png": 1044,
	"./detail/ege-informatika/logoPagePhone.png": 1029,
	"./detail/ege-informatika/spanBorder.svg": 1014,
	"./detail/frontend/6.1.png": 1135,
	"./detail/frontend/6.2.png": 1136,
	"./detail/frontend/6.3.png": 1137,
	"./detail/frontend/6.svg": 964,
	"./detail/frontend/7.svg": 949,
	"./detail/frontend/line.3.svg": 1138,
	"./detail/frontend/line.svg": 979,
	"./detail/frontend/logoPage.png": 1045,
	"./detail/frontend/logoPagePhone.png": 1030,
	"./detail/frontend/spanBorder.svg": 1015,
	"./detail/game-design/6.1.png": 1139,
	"./detail/game-design/6.2.png": 1140,
	"./detail/game-design/6.3.png": 1141,
	"./detail/game-design/6.svg": 965,
	"./detail/game-design/7.svg": 950,
	"./detail/game-design/line.3.svg": 1142,
	"./detail/game-design/line.svg": 980,
	"./detail/game-design/logoPage.png": 1046,
	"./detail/game-design/logoPagePhone.png": 1031,
	"./detail/game-design/spanBorder.svg": 1016,
	"./detail/graphic-design-pro/6.1.png": 1143,
	"./detail/graphic-design-pro/6.2.png": 1144,
	"./detail/graphic-design-pro/6.3.png": 1145,
	"./detail/graphic-design-pro/6.svg": 966,
	"./detail/graphic-design-pro/7.svg": 951,
	"./detail/graphic-design-pro/line.3.svg": 1146,
	"./detail/graphic-design-pro/line.svg": 981,
	"./detail/graphic-design-pro/logoPage.png": 1047,
	"./detail/graphic-design-pro/logoPagePhone.png": 1032,
	"./detail/graphic-design-pro/spanBorder.svg": 1017,
	"./detail/graphic-design/6.1.png": 1147,
	"./detail/graphic-design/6.2.png": 1148,
	"./detail/graphic-design/6.3.png": 1149,
	"./detail/graphic-design/6.svg": 967,
	"./detail/graphic-design/7.svg": 952,
	"./detail/graphic-design/line.3.svg": 1150,
	"./detail/graphic-design/line.svg": 982,
	"./detail/graphic-design/logoPage.png": 1048,
	"./detail/graphic-design/logoPagePhone.png": 1033,
	"./detail/graphic-design/spanBorder.svg": 1018,
	"./detail/greenieLike.svg": 1151,
	"./detail/intensive/6.1.png": 1152,
	"./detail/intensive/6.2.png": 1153,
	"./detail/intensive/6.3.png": 1154,
	"./detail/intensive/6.svg": 968,
	"./detail/intensive/7.svg": 953,
	"./detail/intensive/line.3.svg": 1155,
	"./detail/intensive/line.svg": 983,
	"./detail/intensive/logoPage.png": 1049,
	"./detail/intensive/logoPagePhone.png": 1034,
	"./detail/intensive/spanBorder.svg": 1019,
	"./detail/line-mobile.svg": 1156,
	"./detail/line.3.svg": 1157,
	"./detail/line.svg": 1158,
	"./detail/orangeLight.svg": 1159,
	"./detail/osnovy-programmirovaniya/6.1.png": 1160,
	"./detail/osnovy-programmirovaniya/6.2.png": 1161,
	"./detail/osnovy-programmirovaniya/6.3.png": 1162,
	"./detail/osnovy-programmirovaniya/6.svg": 969,
	"./detail/osnovy-programmirovaniya/7.svg": 954,
	"./detail/osnovy-programmirovaniya/line.3.svg": 1163,
	"./detail/osnovy-programmirovaniya/line.svg": 984,
	"./detail/osnovy-programmirovaniya/logoPage.png": 1050,
	"./detail/osnovy-programmirovaniya/logoPagePhone.png": 1035,
	"./detail/osnovy-programmirovaniya/spanBorder.svg": 1020,
	"./detail/predprinimatelstvo/6.1.png": 1164,
	"./detail/predprinimatelstvo/6.2.png": 1165,
	"./detail/predprinimatelstvo/6.3.png": 1166,
	"./detail/predprinimatelstvo/6.svg": 970,
	"./detail/predprinimatelstvo/7.svg": 955,
	"./detail/predprinimatelstvo/line.3.svg": 1167,
	"./detail/predprinimatelstvo/line.svg": 985,
	"./detail/predprinimatelstvo/logoPage.png": 1051,
	"./detail/predprinimatelstvo/logoPagePhone.png": 1036,
	"./detail/predprinimatelstvo/spanBorder.svg": 1021,
	"./detail/purpleHeart.svg": 1168,
	"./detail/python/6.1.png": 1169,
	"./detail/python/6.2.png": 1170,
	"./detail/python/6.3.png": 1171,
	"./detail/python/6.svg": 971,
	"./detail/python/7.svg": 956,
	"./detail/python/line.3.svg": 1172,
	"./detail/python/line.svg": 986,
	"./detail/python/logoPage.png": 1052,
	"./detail/python/logoPagePhone.png": 1037,
	"./detail/python/spanBorder.svg": 1022,
	"./detail/scratch/6.1.png": 1173,
	"./detail/scratch/6.2.png": 1174,
	"./detail/scratch/6.3.png": 1175,
	"./detail/scratch/6.svg": 972,
	"./detail/scratch/7.svg": 957,
	"./detail/scratch/line.3.svg": 1176,
	"./detail/scratch/line.svg": 987,
	"./detail/scratch/logoPage.png": 1053,
	"./detail/scratch/logoPagePhone.png": 1038,
	"./detail/scratch/spanBorder.svg": 1023,
	"./detail/unity/6.1.png": 1177,
	"./detail/unity/6.2.png": 1178,
	"./detail/unity/6.3.png": 1179,
	"./detail/unity/6.svg": 973,
	"./detail/unity/7.svg": 958,
	"./detail/unity/line.3.svg": 1180,
	"./detail/unity/line.svg": 988,
	"./detail/unity/logoPage.png": 1054,
	"./detail/unity/logoPagePhone.png": 1039,
	"./detail/unity/spanBorder.svg": 1024,
	"./detail/videoblogging/6.1.png": 1181,
	"./detail/videoblogging/6.2.png": 1182,
	"./detail/videoblogging/6.3.png": 1183,
	"./detail/videoblogging/6.svg": 974,
	"./detail/videoblogging/7.svg": 959,
	"./detail/videoblogging/line.3.svg": 1184,
	"./detail/videoblogging/line.svg": 989,
	"./detail/videoblogging/logoPage.png": 1055,
	"./detail/videoblogging/logoPagePhone.png": 1040,
	"./detail/videoblogging/spanBorder.svg": 1025,
	"./detail/web-razrabotka/6.1.png": 1185,
	"./detail/web-razrabotka/6.2.png": 1186,
	"./detail/web-razrabotka/6.3.png": 1187,
	"./detail/web-razrabotka/6.svg": 975,
	"./detail/web-razrabotka/7.svg": 960,
	"./detail/web-razrabotka/line.3.svg": 1188,
	"./detail/web-razrabotka/line.svg": 990,
	"./detail/web-razrabotka/logoPage.png": 1056,
	"./detail/web-razrabotka/logoPagePhone.png": 1041,
	"./detail/web-razrabotka/spanBorder.svg": 1026,
	"./detail/yellowPalms.svg": 1189,
	"./egeChildren.png": 1264,
	"./firstSteps/1.png": 1269,
	"./firstSteps/2.png": 1270,
	"./firstSteps/3.png": 1271,
	"./firstSteps1.png": 1731,
	"./firstSteps2.webp": 1268,
	"./fotoTestimonialsCustomers.webp": 1732,
	"./gift1.svg": 1287,
	"./gift2.svg": 1288,
	"./globe-svg.svg": 1121,
	"./globe.png": 1733,
	"./green-thumb.png": 1326,
	"./greenieLike.svg": 1734,
	"./holiday1.svg": 1289,
	"./holiday2.svg": 1290,
	"./holiday3.svg": 1291,
	"./holiday4.svg": 1292,
	"./learning/learnGif1.gif": 1327,
	"./learning/learnGif2.gif": 1328,
	"./learning/learnGif3.gif": 1329,
	"./learning/learnGif4.gif": 1330,
	"./li/Blue.svg": 1331,
	"./li/Green.svg": 1332,
	"./li/LightCyan.svg": 1333,
	"./li/Lime.svg": 1334,
	"./li/NadeshikoPink.svg": 1335,
	"./li/Pink.svg": 1336,
	"./li/Purple.svg": 1337,
	"./li/Sky.svg": 1338,
	"./li/SpanishPink.svg": 1339,
	"./li/Yellow.svg": 1340,
	"./logoAlg.svg": 1057,
	"./logoFix.svg": 1281,
	"./logoFooter.svg": 1275,
	"./logoFooterMobile.svg": 1276,
	"./logoHeader.svg": 1058,
	"./logoHeaderPc.svg": 1059,
	"./logoNavPopUp.svg": 1060,
	"./menuNav.svg": 1735,
	"./ok.svg": 1736,
	"./orangeLight.svg": 1737,
	"./ozon.png": 1738,
	"./phone.svg": 1282,
	"./placeholder.png": 1341,
	"./professor/professor1.png": 1739,
	"./professor/professor2.png": 1740,
	"./professor/professor3.png": 1741,
	"./professor/professor4.png": 1742,
	"./professor/professor5.png": 1743,
	"./professor/professor6.jpg": 1744,
	"./purpleHeart.svg": 1745,
	"./red-fire.png": 1342,
	"./rf.svg": 1746,
	"./room/room1.jpg": 1747,
	"./room/room2.jpg": 1748,
	"./room/room3.jpg": 1749,
	"./room/room4.jpg": 1750,
	"./sk.svg": 1751,
	"./skY.png": 1752,
	"./star.svg": 1293,
	"./stars.svg": 1343,
	"./subtract.svg": 1753,
	"./subtract2.svg": 1754,
	"./tick.svg": 1755,
	"./triangularRight.svg": 1756,
	"./violet-heart.png": 1344,
	"./yandex.png": 1757,
	"./yellow-hello.png": 1345,
	"./yellow-line-1-desc.svg": 1346,
	"./yellow-line-2-desc.svg": 1347,
	"./yellow-line-slider.svg": 1348,
	"./yellowPalms.svg": 1758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1726;